import axios from "axios";

const baseURL = "https://info-encoding-flask.herokuapp.com/";

export const client = axios.create({ baseURL });

export default { client };
